import * as React from "react"
import { Container } from "@components/styles"
import * as Accordion from "@radix-ui/react-accordion"
import { FaqProps } from "./types"
import {
    FaqWrapper,
    FaqRow,
    LeftCol,
    RightCol,
    AccordionHeader,
    AccordionItem,
    AccordionContent,
    StyledChevron
} from "./styles"

const Faq = ({ id, content, faqItems }: FaqProps) => {
    return <FaqWrapper>
        <Container>
            <FaqRow>
                <LeftCol>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                </LeftCol>
                <RightCol>
                    <Accordion.Root type="multiple">
                        {faqItems?.map((faqItem, index) => (
                            <AccordionItem value={`fagItem-${id}-${index}`}>
                                <AccordionHeader>
                                    <Accordion.Trigger asChild>
                                        <span>
                                            {faqItem.title}
                                            <StyledChevron aria-hidden />
                                        </span>
                                    </Accordion.Trigger>
                                </AccordionHeader>
                                <AccordionContent>
                                    <div dangerouslySetInnerHTML={{ __html: `${faqItem.answer}` }} />
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion.Root>
                </RightCol>
            </FaqRow>
        </Container>
    </FaqWrapper>
}

export default Faq
